import React from 'react';
import Footer from './Footer';
import Header from './Header';

function Team() {
    

    return (
        <>
            <Header/>
          
            <section className="hero-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-5">
                            <h2 className="text-white fw-normal mb-4 mt-3 lh-base">
                                Team
                            </h2>
                        </div>
                    </div>
                </div>
            </section>
            <br />
            <section id="team" className="team section">
                <div className="d-flex justify-content-center">
                    <button type="button" className="btn btn-light rounded-pill">
                        <b>Team</b>
                    </button>
                </div>
                <div>
                    <h1 style={{ textAlign: 'center' }}>
                        <span>Our </span> <span className="link-primary">Financial</span>
                    </h1>
                </div>
                <br />
                <div className="container">
                    <div className="row justify-content-center gy-4">
                        <div className="col-sm-6 col-lg-3">
                            <div className="card">
                                <img src="assets/img/team/Neel.jpg" className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <div className="member-info">
                                        <h4 style={{ textAlign: 'center' }} >Neel Soni</h4>
                                        <span className='d-flex justify-content-center'>Founder &amp; CEO</span>
                                    </div>
                                </div> {/* end card-body */}
                            </div> {/* end card */}
                        </div> {/* end col*/}
                        <div className="col-sm-6 col-lg-3">
                            <div className="card">
                                <img src="assets\img\team\AmishaThakor.jpg" className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <div className="member-info">
                                        <h4 style={{ textAlign: 'center' }} >Amisha Thakor</h4>
                                        <span className='d-flex justify-content-center'>HR  &amp; Administration</span>
                                    </div>
                                </div> {/* end card-body */}
                            </div> {/* end card */}
                        </div> {/* end col*/}
                    </div>
                </div>
            </section>
            <br />
            <section id="team" className="team section light-background">
                <div className="d-flex justify-content-center">
                    <button type="button" className="btn btn-light rounded-pill">
                        <b>Team</b>
                    </button>
                </div>
                <div>
                    <h1 style={{ textAlign: 'center' }}>
                        <span>Our  </span> <span className="link-primary">IT Team</span>
                    </h1>
                </div>
                <br />
                <div className="container">
                    <div className="row gy-4">

                        <div className="col-sm-6 col-lg-3">
                            <div className="card">
                                <img src="assets/img/team/Pratik.jpg" className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <div className="member-info">
                                        <h4 style={{ textAlign: 'center' }} >Pratik Thakor</h4>
                                        <span className='d-flex justify-content-center'>IT Head</span>
                                    </div>
                                </div> {/* end card-body */}
                            </div> {/* end card */}
                        </div> {/* end col*/}

                        <div className="col-sm-6 col-lg-3">
                            <div className="card">
                                <img src="assets/img/team/Harshad.jpg" className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <div className="member-info">
                                        <h4 style={{ textAlign: 'center' }}>Harshad Solanki</h4>
                                        <span className='d-flex justify-content-center'>Developer</span>
                                    </div>
                                </div> {/* end card-body */}
                            </div> {/* end card */}
                        </div> {/* end col*/}

                        <div className="col-sm-6 col-lg-3">
                            <div className="card">
                                <img src="assets/img/team/Dhruv.jpg" className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <div className="member-info">
                                        <h4 style={{ textAlign: 'center' }}>Dhruv Patel</h4>
                                        <span className='d-flex justify-content-center'>Developer</span>
                                    </div>
                                </div> {/* end card-body */}
                            </div> {/* end card */}
                        </div> {/* end col*/}
                        
                        <div className="col-sm-6 col-lg-3">
                            <div className="card">
                                <img src="assets/img/team/Radhe.jpg" className="card-img-top" alt="..." />
                                <div className="card-body">
                                    <div className="member-info">
                                        <h4 style={{ textAlign: 'center' }}>Nirmal Solanki</h4>
                                        <span className='d-flex justify-content-center'>Developer &amp; Designer</span>
                                    </div>
                                </div> {/* end card-body */}
                            </div> {/* end card */}
                        </div> {/* end col*/}
                    </div>
                </div>
            </section>
            <br />
            <Footer />
        </>

    )
}

export default Team
